import { Elements, Descriptions, Tag } from 'types';
import { ILoader } from 'managers/base.manager/standard';
import { prepareElement } from 'helpers/element';
// @ts-ignore
import standardBase from 'little-alchemy-base/base/web/game.json';

export class StandardBaseLoader implements ILoader {
  public async loadBase() {
    const rawElements = await this.fetchBase();
    const elements: Elements = {};
    Object.entries(rawElements).forEach(([id, element]) => {
      elements[id] = prepareElement(element, id);
    });

    return elements;
  }
  protected fetchBase() {
    return Promise.resolve(standardBase);
  }

  public async loadDescriptions(): Promise<Descriptions> {
    const descriptions = await this.fetchDescriptions();
    return descriptions;
  }
  protected async fetchDescriptions() {
    // @ts-ignore
    // tslint:disable-next-line:max-line-length
    const descriptionsModule = await import(/* webpackChunkName: "descriptions" */ 'little-alchemy-base/base/descriptions.json');
    return descriptionsModule.default;
  }

  public async loadTags(): Promise<Tag[]> {
    const descriptions = await this.fetchTags();
    return descriptions;
  }
  protected async fetchTags() {
    // @ts-ignore
    const tagsModule = await import(/* webpackChunkName: "tags" */ 'little-alchemy-base/base/tags.json');
    return tagsModule.default;
  }
}

export default StandardBaseLoader;
